export default __webpack_public_path__ + "static/media/hvar2.0f2f7562.jpg";